import { userConstants } from '../_constants';

export function moneyBackList(state = {}, action) {
    switch (action.type) {
        case userConstants.MONEY_BACK_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case userConstants.MONEY_BACK_LIST_SUCCESS:
            return {
                ...state,
                ...action.data,
                loading: false,
            };
        case userConstants.MONEY_BACK_LIST_FAILURE:
            return {
                error: action.error,
            };

        default:
            return state;
    }
}